import { api } from '../lib/api';
import { queryClient } from '../providers/query-client';

export async function cmsLoader() {
    const claims = await queryClient.fetchQuery({
        queryKey: ['cms'],
        queryFn: async () => {
            const { data } = await api.formCms.findAll();
            return data;
        },
    });
    return claims;
}
